import type { FC } from "react";
import { useCallback } from "react";
import { createURL } from "expo-linking";
import { useQueryClient } from "@tanstack/react-query";

import { api } from "~/utils/api";
import { authClient } from "~/utils/auth";
import { GoogleIcon } from "~/component/icons/google-icon";
import config from "~/config";
import type {
  SocialButtonAuthParams,
  SocialButtonProps,
} from "./social-button";
import { SocialButton } from "./social-button";

export interface GoogleButtonProps extends Omit<SocialButtonProps, "Icon"> {
  authParams?: SocialButtonAuthParams;
}

export const GoogleButton: FC<GoogleButtonProps> = ({
  authParams,
  ...props
}) => {
  const apiUtils = api.useUtils();
  const queryClient = useQueryClient();

  const handlePress = useCallback(async () => {
    await authClient.signIn.social({
      provider: "google",
      callbackURL: createURL("auth"),
      errorCallbackURL: createURL("auth"),
      ...authParams,
    });

    queryClient.clear();
    await apiUtils.context.person.fetch();
  }, [apiUtils.context.person, authParams, queryClient]);

  if (!config.SOCIAL_PROVIDERS?.includes("google")) return null;

  return <SocialButton Icon={GoogleIcon} onPress={handlePress} {...props} />;
};
